// imports
import * as THREE from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader"
import { gsap } from "gsap"

// classes
import Experience from "../Experience"
import EventEmitter from "./EventEmitter"

export default class ResourceLoader extends EventEmitter
{
    constructor()
    {
        // override
        super()

        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sources = this.experience.sources
        this.overlay = this.experience.overlay

        // options
        this.items = {}
        this.toLoad = this.sources.instance.length
        this.loaded = 0

        this.setInstance()
        this.startLoading()
    }

    setInstance()
    {
        this.loadingManager = new THREE.LoadingManager()

        // texture&CubeTexture
        this.textureLoader = new THREE.TextureLoader( this.loadingManager )
        this.cubeLoader = new THREE.CubeTextureLoader( this.loadingManager )

        // gltf&draco
        this.gltfLoader = new GLTFLoader( this.loadingManager )
        this.dracoLoader = new DRACOLoader( this.loadingManager )

        // set draco
        this.dracoLoader.setDecoderPath( "/draco/" )
        this.gltfLoader.setDRACOLoader( this.dracoLoader )
        this.dracoLoader.setDecoderConfig( { type: 'js' } );
        this.dracoLoader.preload()

        // audio
        this.audioLoader = new THREE.AudioLoader( this.loadingManager )
    }

    startLoading()
    {
        for ( const source of this.sources.instance )
        {
            switch ( source.type )
            {
                case "texture":

                this.textureLoader.load( source.path, ( _file ) =>
                {
                    this.onLoad( source, _file )
                } )
                break
       
                case "cubeTexture":

                this.cubeLoader.load( source.path, ( _file ) =>
                {
                    this.onLoad( source, _file )
                } )
                break

                case "gltfModel":

                this.gltfLoader.load( source.path, ( _file ) =>
                {
                    this.onLoad( source, _file )
                } )
                break

                case "dracoModel":

                this.gltfLoader.load( source.path, ( _file ) =>
                {
                    this.onLoad( source, _file )
                } )
                break

                case "audio":

                this.audioLoader.load( source.path, ( _file ) =>
                {
                    this.onLoad( source, _file )
                } )
                break

            }
        }

        this.loadingManager.onProgress = ( _itemUrl, _itemsLoaded, _itemsTotal) =>
        {
            const progressRatio = ( _itemsLoaded / _itemsTotal ) * 2000

            gsap.to( this.overlay.loadingBar.scale, { duration: 1, x: progressRatio, y: 2, z: 2 } )
        }
    }

    onLoad( _source, _file )
    {
        this.items[ _source.name ] = _file
        this.loaded ++

        if  ( this.loaded === this.toLoad )
        {
            window.setTimeout( () =>
            {
                gsap.to( this.overlay.overlayMaterial.uniforms.uAlpha, { duration: 2, value:0 } )
                gsap.to( this.overlay.loadingBar.position, { duration: 2, x: 20, y: 0.01, z: 0.01, onComplete: () =>
                {
                    this.scene.remove( this.overlay.overlay, this.overlay.loadingBar )
                } } )
            }, 100 )
            this.trigger( "itemsLoaded" )
        }
    }
}